export default {
  LOGDNA_INGESTION_KEY: process.env.LOGDNA_INGESTION_KEY ?? "86e2bf58c669c293e6525e49eab86a0c",
};
